/* unplugin-vue-components disabled */import { render } from "./purchase-cart.vue?vue&type=template&id=6130c73b"
import script from "./purchase-cart.vue?vue&type=script&lang=js"
export * from "./purchase-cart.vue?vue&type=script&lang=js"

import "./purchase-cart.vue?vue&type=style&index=0&id=6130c73b&lang=scss"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__